import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./app_en.json";
import koTranslations from "./app_ko.json";

// 지원하는 언어 목록
export const SUPPORTED_LANGUAGES = ["en", "ko"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// 기기 언어가 지원되는 언어인지 확인
const isSupportedLanguage = (lang: string): lang is SupportedLanguage => {
  return SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);
};

// 기기의 언어 감지
const detectLanguage = (): SupportedLanguage => {
  // 브라우저의 언어 설정 가져오기
  const browserLang = navigator.language.split("-")[0];

  // 지원하는 언어인지 확인하고 반환
  return isSupportedLanguage(browserLang) ? browserLang : "en";
};

// 초기 언어 설정
const initialLanguage = detectLanguage();

export const resources = {
  en: {
    translation: enTranslations,
  },
  ko: {
    translation: koTranslations,
  },
} as const;

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
    returnEmptyString: false;
    returnObjects: true;
    resources: typeof resources;
    defaultNS: "translation";
  }
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  returnEmptyString: false,
  returnObjects: true,
});

export default i18n;

// 언어 변경 함수
export const changeLanguage = async (language: SupportedLanguage) => {
  await i18n.changeLanguage(language);
  localStorage.setItem("i18nextLng", language);
};